/* global $, angular, _ */

'use strict';

import template from '../../../templates/template-field.html';
import escape from 'lodash/escape';

angular.module('atex.aceui.ui').directive('templateField',
  ['$compile', '$window', function ($compile, $window) {
    return {
      restrict: 'E',

      scope: {
        field: '<',
        mode: '@'
      },

      template,

      controller: function ($scope) {
        if (typeof $scope.field !== 'undefined') {
          $scope.config = atex.aceui.ObjectUtils.getByPath($scope, 'field/dataBinding/config') || {};
          $scope.domainObject = atex.aceui.ObjectUtils.getByPath($scope, 'field/domainObject');
          $scope.domainObjects = atex.aceui.ObjectUtils.getByPath($scope, 'field/domainObjects') || {};

          $scope.label = escape(atex.aceui.ObjectUtils.getByPath($scope, 'field/dataBinding/label') || '');
          $scope.showExpandableHelpText = false;

          var required = atex.aceui.ObjectUtils.getByPath($scope, 'field/dataBinding/required') || false;
          var validationContext = atex.aceui.ObjectUtils.getByPath($scope, 'field/validationContext');
          if (typeof validationContext !== 'undefined') {
            $scope.validation = {required: required, context: validationContext};
          }
        }

        $scope.toggleExpandableHelpText = function () {
          $scope.showExpandableHelpText = !$scope.showExpandableHelpText;
        };

        $scope.activateField = (event) => {
          $($window.document.getElementById($scope.field.widgetId)).focus();
          event.stopImmediatePropagation();
          event.stopPropagation();
        };
      },

      link: function (scope, element) {
        if (typeof scope.field === 'undefined') {
          console.warn('No field information supplied to template field rendering, skipping...');
          return;
        }

        let tabindex = scope.mode === 'edit' ? 'tabindex="-1"' : '';

        element.append(
          `<div id="${scope.field.widgetId}" class="template-field-content" ${scope.field.widgetNameDashed} base-url="${scope.field.baseUrl}" widget-id="${scope.field.widgetId}"
                ${tabindex} data-field-name="${scope.field.dataBinding.name}" data-config="config" data-domain-object="domainObject" data-domain-objects="domainObjects" data-validation="validation"
                data-aria="{ labelledby: 'field-label-${scope.field.widgetId}', describedby: 'field-description-${scope.field.widgetId}' }"
                data-test="template-field-content" x-mode="${scope.field.mode}"></div>`
        );
        element.append('<div id="not-valid-' + scope.field.widgetId + '"></div>');

        var cssClass = scope.field.dataBinding.cssClass || '';
        element.addClass('template-field ' +  cssClass);

        $compile(element.contents())(scope);
      }
    };
  }]);
